<template>
  <!-- Компонент вопрос -->
  <QuizQuestion :question="question" />
  <!-- Компонент вопрос -->

  <div
  class="quiz-options quiz__multiple-choice"
  :class="{ 'quiz__multiple-choice--long': hasLongText }"
  >
    <div
      v-for="(option, index) in question.options"
      :key="index"
      class="quiz__option"
      :class="{
          'selected': isSelected(index),
          'correct': showResults && question.correct_options && question.correct_options.includes(index),
          'incorrect': showResults && isSelected(index) && question.correct_options && !question.correct_options.includes(index)
        }"
      @click="toggleOption(index)"
      :aria-disabled="showResults"
      tabindex="0"
    >
      <div class="quiz__option-icon">
        <svg class="icon-correct">
          <use xlink:href="/static/img/sprites/sprite.svg#correct"></use>
        </svg>
      </div>

      <span v-html="option.text"></span>

      <div class="quiz__option-img">
        <picture>
          <source :srcset="option.imageWebp" type="image/webp" v-if="option.imageWebp">
          <img
              v-if="option.image"
              :src="option.image"
              :alt="option.text || ''"
          >
        </picture>
        <img
          v-if="option.image"
          :src="option.image"
          :alt="option.text || ''"
        >
      </div>
    </div>
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion/QuizQuestion.vue";

export default {
  name: 'MultipleChoice',
  components: {
    QuizQuestion
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedAnswers: {
      type: Array,
      default: () => []
    },
    showResults: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answers-updated'],
  methods: {
    isSelected(index) {
      if (Array.isArray(this.selectedAnswers)) {
      return this.selectedAnswers.includes(index);
      }
      return false;
    },
    toggleOption(index) {
      if (this.showResults) return;

      // Проверяем, что selectedAnswers - массив
      const selectedAnswersArray = Array.isArray(this.selectedAnswers) ? this.selectedAnswers : [];
      const newSelection = [...selectedAnswersArray];
      const selectionIndex = newSelection.indexOf(index);

      if (selectionIndex !== -1) {
        newSelection.splice(selectionIndex, 1); // Убираем выбор
      } else {
        // Проверка максимального количества ответов
        if (this.question.maxAnswers && newSelection.length >= this.question.maxAnswers) {
          newSelection.shift(); // Удаляем первый элемент если превысили лимит
        }
        newSelection.push(index); // Добавляем новый выбор
      }

      this.$emit('answers-updated', this.question.id, newSelection);
    },
    getSelectedCount() {
      if (Array.isArray(this.selectedAnswers)) {
      return this.selectedAnswers.length;
      }
      return 0;
    }
  },
  computed: {
    hasLongText() {
      if (!this.question.options || !this.question.options.length) return false;
      return this.question.options.some(option => option.text && option.text.length > 35);
    }
  }
};
</script>

<style lang="scss">
.quiz-options.quiz__multiple-choice {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 12px;

  & .quiz__option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 8px;

    @media (min-width: $lg) {
      padding: 11px;
    }

    & span {
      margin-bottom: auto;
      padding-right: 20px;
    }

    & .quiz__option-img {
      width: 100%;
      overflow: hidden;
      aspect-ratio: 3/2;
      border: 1px solid var(--bg, #F7F6F7);
      border-radius: 16px;

      & img {
        width: 100%;
        object-fit: cover;
        height: 100%;
      }
    }

    &-img {
      width: 100%;
      border-radius: 0;
      overflow: hidden;
      & img {
        width: 100%;
        object-fit: contain;
      }
    }

    &-icon {
      top: 21px;
      right: 9px;
    }
  }

  // длинный текст
  &.quiz__multiple-choice--long {
    display: flex;
    flex-direction: column;

    & .quiz__option {
      @include text-16-700;

      display: grid;
      grid-template-columns: 1fr 132px;
      border-radius: 24px;

      & span {
        padding-right: 0;
      }

      & .quiz__option-icon {
        top: 31px;
        right: 14px;
        padding: 6px;
        width: 32px;
        height: 32px;
        background-color: var(--white);
        border-radius: 100%;

        & svg {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
</style>
